import React, {Component} from "react";
import {PAYLOAD} from "../payloads";

const OperatorIco = <svg width="30.619" height="30.619" viewBox="0 0 30.619 30.619" className="sm-operator">
    <g id="icon" transform="translate(0 0)">
        <g id="Ellipse_52" data-name="Ellipse 52" transform="translate(0 0)" fill="#fff"
           stroke={`${window.STYLE_MESSAGE_OPERATOR_COLOR ? window.STYLE_MESSAGE_OPERATOR_COLOR : "#005ba8"}`}
           strokeWidth="2">
            <circle cx="15.31" cy="15.31" r="15.31" stroke="none"/>
            <circle cx="15.31" cy="15.31" r="14.31" fill="none"/>
        </g>
        <path id="Path_594" data-name="Path 594"
              d="M15.545,9.4V7.773c0-2.826-1.413-6.359-4.24-6.359,0,0-.707-1.413-3.533-1.413A7.819,7.819,0,0,0,0,7.773v3.533a2.929,2.929,0,0,0,1.555,2.685,6.871,6.871,0,0,0,6.218,4.381,6.378,6.378,0,0,0,3.957-1.413H7.773c-3.674,0-4.946-3.6-5.017-3.745l-.141-.353-.353-.141a1.317,1.317,0,0,1-.848-1.413V10.6H2.12c0-4.946,7.066-1.413,9.186-6.359,0,0,2.12,1.978,2.12,6.359v2.12h.565a2.058,2.058,0,0,1-1.978,1.413h-2.9a1.063,1.063,0,0,0-.989-.707H7.419a1.06,1.06,0,0,0,0,2.12h4.593a3.446,3.446,0,0,0,3.462-2.968,1.457,1.457,0,0,0,.777-1.272V10.6A1.368,1.368,0,0,0,15.545,9.4Z"
              transform="translate(7.145 6.124)"
              fill={`${window.STYLE_MESSAGE_OPERATOR_COLOR ? window.STYLE_MESSAGE_OPERATOR_COLOR : "#005ba8"}`}/>
    </g>
</svg>;

class Receiver extends Component {
    state = {
        hours: null,
        minutes: null,
    };

    componentDidMount() {
        this.formatDate()
    }

    formatDate = () => {
        const date = new Date();
        let hours = date.getHours();
        if (hours < 10) hours = "0" + hours;
        let minutes = date.getMinutes();
        if (minutes < 10) minutes = "0" + minutes;

        this.setState({hours, minutes})
    };

    render() {
        let {onMessage, isShow, time, data, config, handlerCarouselLength} = this.props;

        if(data && data.type === "CAROUSEL" && data.cards) {
            handlerCarouselLength(data.cards.length);
        }

        if (PAYLOAD(data) !== undefined) {
            return (
                <div className={`receiver ${time ? 'withTime' : ''}`}>
                    {OperatorIco}
                    <div className="sm-mes-content">
                        <div className="w-sm-header">
                            {PAYLOAD(data, onMessage, isShow, config)}
                            {time ? <span className="timer">{time}</span> : <span className="timer client-timer">{this.state.hours}:{this.state.minutes}</span>}
                        </div>
                    </div>
                </div>
            )
        } else {
            return false;
        }
    }
}

export default Receiver;


// WEBPACK FOOTER //
// ./src/components/Body/Receiver/index.js